export default __webpack_public_path__ + "static/media/IC_address_book.b5f2dbea.svg";